import { inject, Injectable } from '@angular/core';

// Services
import { AppFunctionalitiesService } from './appFunctionalities/appFunctionalities.service';
import { ConfigService } from './config/config.service';
import { ActivationCodeService } from './activation-code/activation-code.service';
import { ToReproduceService } from './toReproduce/toReproduce.service';
import { TrialService } from './trial/trial.service';

@Injectable()
export class ApiService {
  public appFunctionalities = inject(AppFunctionalitiesService);
  public config = inject(ConfigService);
  public activationCode = inject(ActivationCodeService);
  public toReproduce = inject(ToReproduceService);
  public trial = inject(TrialService);
}
